import moment from 'moment-timezone';

// Param format: 2021-01-15 10:16:09
export const formatDate = (d) => moment(d).tz('Etc/GMT+1').add(3, 'hours').format('YYYY-MM-DD HH:mm');


// WEBPACK FOOTER //
// ./src/js/helpers/formatDate.js